var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 36,
    viewBox: "0 0 94 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 51,
    rx: 6.5,
    fill: "#203245",
    stroke: "#314964"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2599 16.4609C55.2533 15.522 53.1076 14.8397 50.8644 14.4512C50.5889 14.9493 50.2671 15.6192 50.0452 16.1521C47.6606 15.7935 45.2979 15.7935 42.9572 16.1521C42.7353 15.6192 42.4061 14.9493 42.1282 14.4512C39.8825 14.8397 37.7344 15.5245 35.7277 16.4659C31.6802 22.5822 30.583 28.5466 31.1316 34.4263C33.8162 36.431 36.4178 37.6488 38.9755 38.4457C39.607 37.5766 40.1702 36.6527 40.6554 35.6789C39.7313 35.3278 38.8463 34.8945 38.01 34.3914C38.2318 34.2271 38.4489 34.0552 38.6585 33.8784C43.7593 36.2642 49.3015 36.2642 54.3414 33.8784C54.5535 34.0552 54.7705 34.2271 54.9899 34.3914C54.1512 34.8969 53.2637 35.3303 52.3396 35.6814C52.8248 36.6527 53.3856 37.5791 54.0195 38.4482C56.5797 37.6513 59.1837 36.4335 61.8682 34.4263C62.512 27.6102 60.7686 21.7006 57.2599 16.4609ZM41.3504 30.8103C39.8191 30.8103 38.5634 29.3808 38.5634 27.6401C38.5634 25.8993 39.7923 24.4674 41.3504 24.4674C42.9084 24.4674 44.1641 25.8968 44.1373 27.6401C44.1397 29.3808 42.9084 30.8103 41.3504 30.8103ZM51.6495 30.8103C50.1183 30.8103 48.8626 29.3808 48.8626 27.6401C48.8626 25.8993 50.0915 24.4674 51.6495 24.4674C53.2076 24.4674 54.4633 25.8968 54.4365 27.6401C54.4365 29.3808 53.2076 30.8103 51.6495 30.8103Z",
    fill: "#6B758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.e6eb2671d78dfef46f93b69483842054.svg";
export { ForwardRef as ReactComponent };